export class Bidding {
    uid: string;
    purchasingOrgan: string;
    product: string;
    sentUserUID: string;
    companyUID: string;
    creationDate: number;
    creationDateString: string;
    productDateString: string;
    biddingDate: number;
    biddingDateString: string;
    status: BiddingStatus;
    refusedReason: string;
    companyMaximumPrice: number;
    earningPrice: number;
    lostPrice: number;
    lostCompetitor: string;
    noticeURL: string;
    observations: string;
    biddable: string;

    updatingDate: number;
    updatingAction: BiddingUpdateAction;

    edital: string;
    limitDate: number;
    limitDateString: string;
    biddingType: string;
    tipoJulgamento: string;
    prazoPagamento: string;
    localEntrega: string;
    amostra: string;
    laudoTecnico: string;
    visitaTecnica: string;
    descricaoVisitaTecnica: string;
    garantiaContratual: string;
    descricaoServicos: string;
    documentacaoTecnica: string;
    descricaoDocumentacaoTecnica: string;

    acceptList: any[];
    participants: string;
    position: string;
}

export enum BiddingStatus {
    NEW = 1,
    ACCEPTED = 2,
    REFUSED = 3,
    EARNED = 4,
    LOST = 5,
    FAIL = 6
}

export enum BiddingUpdateAction {
    CREATED,
    UPDATED,
    ACCEPTED,
    REFUSED,
    EARNED,
    LOST, 
    FAIL
}


// WEBPACK FOOTER //
// ./src/app/model/bidding.ts